import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PDF from "../../../../assets/images/pdf.svg";
import { getCampaignView } from "../../../../redux/actions/campaignActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import ProfilePic from "../../../../assets/images/dummy_profile.png";
import "../../../../components/common/css/campaignview.scss";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Close from "../../../../assets/images/close-icon.png";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PausedCampaignView = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const campaignView = useSelector((state) => state.campaignView);
  const { campaign } = campaignView;
  const navigate = useNavigate();
  const id = useParams();
  let campaign_id = campaign?.data[0]?.id?.toString()?.padStart(8, "0");
  let token = localStorage.getItem("accessToken");
  const [open, setOpen] = useState(false);
  const [history, setHistory] = useState([]);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (campaignView) {
      if (campaignView?.loading !== undefined) {
        setLoading(campaignView?.loading);
      }
    }
  }, [campaignView]);

  useEffect(() => {
    dispatch(getCampaignView(token, id));
  }, []);

  const dateFormat = (date) => {
    const notificationDate = new Date(date);
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let temp =
      months[notificationDate.getMonth()] +
      " " +
      notificationDate.getDate() +
      ", " +
      notificationDate.getFullYear() +
      "   at  " +
      notificationDate.getHours() +
      ":" +
      notificationDate.getMinutes();
    return temp;
  };

  const viewHstory = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "admin/getAllLogsofCamapignbyId",
      headers: {
        "x-access-token": token,
      },
      data: {
        slug: campaign?.data[0]?.slug,
        user_id: campaign?.data[0]?.user_id,
        campaign_id: id.campaignId,
      },
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        // console.log(response?.data?.data?.rows);

        setHistory(response?.data?.data?.rows);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };
  // console.log(history,"xyz");
  useEffect(() => {
    if (campaignView) {
      if (
        campaignView?.campaign?.status == 200 &&
        campaignView?.campaign?.success == true
      ) {
        viewHstory();
      }
    }
  }, [campaignView]);

  const handleOpen = () => {
    setOpen(true);
  };

  const pauseCampaign = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "update-campaign-status",
      headers: {
        "x-access-token": token,
      },
      data: {
        campaign_id: id.campaignId,
        campaign_status: 3,
      },
    };
    axios(config)
      .then(function (response) {
        if (response.data.status == 200) {
          setLoading(false);
          Swal.fire({
            title: "Campaign Active Succesffully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        navigate("/active-campaign");
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response !== "" && error.response.data.message !== "") {
          Swal.fire({
            title: "Error",
            timer: 2500,
            timerProgressBar: true,
            text: error.response.data.message,
            icon: "error",
            confirmButtonColor: "#f27474",
            confirmButtonText: "OK",
            dangerMode: true,
            showCloseButton: true,
          });
        }
      });
  };

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="top">
          {campaign?.data?.map((userInfo, i) => (
            <>
              <div className="left">
                {/* <div className="editButton">Edit</div> */}
                <div className="title-topSection">
                  <h1 className="title">Personal Information</h1>
                  <button onClick={handleOpen} className="editButton">
                    History
                  </button>
                </div>
                <div className="item">
                  <img
                    src={
                      userInfo?.user?.profilePic == null
                        ? ProfilePic
                        : userInfo?.user?.profilePic
                    }
                    alt=""
                    className="itemImg"
                  />
                  <div className="details profile-info">
                    {/* <h1 className="itemTitle">
                      {userInfo.user.firstname} {userInfo.user.lastname}
                    </h1> */}
                    <div className="detailItem">
                      <span className="itemKey">Name:</span>
                      <span className="itemValue">
                        <b>
                          {userInfo?.user?.salutations}&nbsp;
                          {userInfo.user.firstname} {userInfo?.user?.lastname}
                        </b>
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Email:</span>
                      <span className="itemValue">{userInfo.user.email}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Phone:</span>
                      <span className="itemValue">
                        {userInfo.user.mobile == "null"
                          ? ""
                          : userInfo.user.mobile}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Status:</span>
                      <span className="itemValue">
                        {userInfo?.campaign_status == 4
                          ? "Completed"
                          : "Inactive"}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Country:</span>
                      <span className="itemValue">
                        {userInfo?.user?.user_country?.country_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">State/Province:</span>
                      <span className="itemValue">
                        {userInfo?.user?.user_state?.state_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Current Address:</span>
                      <span className="itemValue">
                        {userInfo?.user?.current_address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">City:</span>
                      <span className="itemValue">{userInfo?.user?.city}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Postal Code:</span>
                      <span className="itemValue">
                        {userInfo?.user?.postal_code}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">DOB:</span>
                      <span className="itemValue">{userInfo?.user?.dob}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Gender:</span>
                      <span className="itemValue">
                        {userInfo?.user?.gender}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Marital Status:</span>
                      <span className="itemValue">
                        {userInfo?.user?.marital_status}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Employer:</span>
                      <span className="itemValue">
                        {userInfo?.user?.employer}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Occupation:</span>
                      <span className="itemValue">
                        {userInfo?.user?.occupation}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="left">
                {/* <div className="editButton">Edit</div> */}
                <h1 className="title">Corporate Information</h1>
                <div className="item">
                  {userInfo?.campaing_logo != null ||
                  userInfo?.campaing_logo == !"" ? (
                    <img
                      src={
                        userInfo?.campaing_logo == null
                          ? ProfilePic
                          : userInfo?.campaing_logo
                      }
                      alt=""
                      className="itemCorpImg"
                    />
                  ) : (
                    ""
                  )}
                  <div className="details profile-info">
                    <div className="detailItem">
                      <span className="itemKey">Campaign ID:</span>
                      <span className="itemValue">{campaign_id}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Company Name:</span>
                      <span className="itemValue">
                        {userInfo.corporation_legal_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Company Location:</span>
                      <span className="itemValue">{userInfo.city}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Campaign Type:</span>
                      <span className="itemValue">{userInfo.campaign_for}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Head Office Address</span>
                      <span className="itemValue">
                        {userInfo.registered_address}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Country</span>
                      <span className="itemValue">
                        {userInfo?.user_country?.country_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">State/Province</span>
                      <span className="itemValue">
                        {userInfo?.user_state?.state_name}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Type Of Enitity:</span>
                      <span className="itemValue">{userInfo.entitytype}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Buisness No:</span>
                      <span className="itemValue">{userInfo.business}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Fax</span>
                      <span className="itemValue">{userInfo.fax}</span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Crax Acoount</span>
                      <span className="itemValue">
                        {userInfo.craax_account}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Date Of Corp</span>
                      <span className="itemValue">
                        {userInfo.date_of_incorp}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Currency</span>
                      <span className="itemValue">
                        CAD {/* {userInfo?.user?.defaultcurrency} */}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Goal Amount</span>
                      <span className="itemValue">
                        {/* {userInfo?.user?.defaultcurrency == "INR"
                          ? "₹"
                          : userInfo?.user?.defaultcurrency == "EUR"
                          ? "€"
                          : "$"} */}
                        ${userInfo?.goal_invest_amnt}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Minimum Investment</span>
                      <span className="itemValue">
                        {/* {userInfo?.user?.defaultcurrency == "INR"
                          ? "₹"
                          : userInfo?.user?.defaultcurrency == "EUR"
                          ? "€"
                          : "$"} */}
                        ${userInfo?.minimum_investment}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Other Investment</span>
                      <span className="itemValue">
                        {/* {userInfo?.user?.defaultcurrency == "INR"
                          ? "₹"
                          : userInfo?.user?.defaultcurrency == "EUR"
                          ? "€"
                          : "$"} */}
                        ${userInfo?.outside_roots_investment}
                      </span>
                    </div>
                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">Company Valuation</span>
                        <span className="itemValue">
                          {/* {userInfo?.user?.defaultcurrency == "INR"
                          ? "₹"
                          : userInfo?.user?.defaultcurrency == "EUR"
                          ? "€"
                          : "$"} */}
                          ${userInfo?.company_valuation}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">In Which Form</span>
                        <span className="itemValue">{userInfo?.loan_type}</span>
                      </div>
                    )}
                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">No Closing Minimum</span>
                        <span className="itemValue">
                          {/* {userInfo?.user?.defaultcurrency == "INR"
                          ? "₹"
                          : userInfo?.user?.defaultcurrency == "EUR"
                          ? "€"
                          : "$"} */}
                          ${userInfo?.no_closing_minimum}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">
                          Brief description on how you will use this funds
                        </span>
                        <span className="itemValue">{userInfo?.fund_use}</span>
                      </div>
                    )}
                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">Price per security</span>
                        <span className="itemValue">
                          {userInfo?.price_per_security}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">
                          Which Is The Purpose Of This Financing?
                        </span>
                        <span className="itemValue">
                          {userInfo?.purpose_of_financing}
                        </span>
                      </div>
                    )}
                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">Security Type</span>
                        <span className="itemValue">
                          {userInfo?.security_type}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">
                          Which return you would like to offer to the investors?
                        </span>
                        <span className="itemValue">
                          {userInfo?.interest_rate}
                        </span>
                      </div>
                    )}
                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">
                          Number of shares issued in this campaign
                        </span>
                        <span className="itemValue">
                          {userInfo?.issued_shares}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">
                          What's your desired loan's duration in months?
                        </span>
                        <span className="itemValue">
                          {userInfo?.loan_duration_in_month}
                        </span>
                      </div>
                    )}

                    {userInfo?.type === "EQUITY" ? (
                      <div className="detailItem">
                        <span className="itemKey">
                          Total Company’s shares issued
                        </span>
                        <span className="itemValue">
                          {userInfo?.issued_shares_company}
                        </span>
                      </div>
                    ) : (
                      <div className="detailItem">
                        <span className="itemKey">
                          Can you offer any guarantees to the investor?
                        </span>
                        <span className="itemValue">
                          {userInfo?.guarantee_type}
                        </span>
                      </div>
                    )}
                    <div className="detailItem">
                      <span className="itemKey">Year Of Corporation</span>
                      <span className="itemValue">
                        {userInfo.how_many_yearsin_business}
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Feature</span>
                      {Array.isArray(userInfo?.features) ? (
                        userInfo?.features.map((feature, index) => {
                          return (
                            <li className="itemValue">
                              {feature?.feature_title}
                            </li>
                          );
                        })
                      ) : (
                        <h4>No Data Found</h4>
                      )}
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Nature Of Buisness</span>
                      {Array.isArray(userInfo?.nature_of_businesses) ? (
                        userInfo?.nature_of_businesses.map((cat, index) => {
                          return (
                            <li className="itemValue">
                              {cat?.business_category?.category_name}
                            </li>
                          );
                        })
                      ) : (
                        <h4>No Data Found</h4>
                      )}
                    </div>

                    <div className=" buisnessPlan">
                      <span className="itemKey">Buisness Plan Docs</span>
                      <div className="itemValue">
                        {userInfo?.business_plan_docs?.length > 0 ? (
                          userInfo?.business_plan_docs?.map((pdf, i) => (
                            <>
                              {pdf?.is_other == 0 && (
                                <a
                                  href={pdf.document_name}
                                  target="_blank"
                                  className="docLink"
                                >
                                  {pdf?.document_name !== null && (
                                    <img src={PDF} className="docImage" />
                                  )}

                                  {pdf?.document_name !== null && (
                                    <p className="docName">doc {i + 1}</p>
                                  )}
                                </a>
                              )}
                            </>
                          ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                    </div>

                    <div div className=" buisnessPlan">
                      <span className="itemKey">Other docs</span>
                      {userInfo?.business_plan_docs?.length > 0 ? (
                        userInfo?.business_plan_docs?.map((pdf, i) => (
                          <>
                            {pdf?.is_other != 0 && (
                              <a
                                href={pdf.is_other}
                                target="_blank"
                                className="docLink"
                              >
                                {pdf?.is_other !== null && (
                                  <img src={PDF} className="docImage" />
                                )}

                                {pdf?.is_other !== null && (
                                  <p className="docName">doc {i + 1}</p>
                                )}
                              </a>
                            )}
                          </>
                        ))
                      ) : (
                        <h6>No Data Found</h6>
                      )}
                    </div>
                    <div className="buisnessPlan">
                      <span className="itemKey">Campaign Banner</span>
                      <div className="itemValue">
                        {userInfo?.banner_img != null ||
                        userInfo?.banner_img == !"" ? (
                          <img
                            src={
                              userInfo?.banner_img == null
                                ? ProfilePic
                                : userInfo?.banner_img
                            }
                            alt=""
                            className="campaignBanner-img"
                          />
                        ) : (
                          "No Data Found"
                        )}
                      </div>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Product:</span>

                      <span className="itemValue">
                        product
                        {/* {userInfo?.product} */}
                      </span>
                    </div>

                    {/* <div className=" idDocs">
                      <span className="itemKey">Id Proof Docs</span>
                      <div className="itemValue">
                        {userInfo?.id_proof_docs?.length > 0 ? (
                          userInfo?.id_proof_docs?.map((id, i) => (
                            <>
                              <a
                                href={id.document_name}
                                target="_blank"
                                className="docLink"
                              >
                                {id.document_name !== null && (
                                  <img
                                    src={id?.document_name}
                                    className="docImage"
                                  />
                                )}
                                {id?.document_name !== null && (
                                  <p className="docName">doc {i + 1}</p>
                                )}
                              </a>
                              {/* <p>{document}</p> */}
                    {/* </> */}
                    {/* ))
                        ) : (
                          <h6>No Data Found</h6>
                        )}
                      </div>
                    // </div> */}
                  </div>
                </div>
              </div>
              <div className="left">
                {/* <div className="editButton">Edit</div> */}
                <h1 className="title">Campaign related Questions/Answers</h1>
                <div className="item">
                  <div className="details profile-info">
                    {userInfo?.campaign_que_ans?.length > 0 ? (
                      userInfo?.campaign_que_ans?.map((que) => (
                        <div className="detailItem companyInfo" key={que.q_id}>
                          <span className="itemKey">{que.question}:</span>
                          <span className="itemValue">{que.answer}</span>
                        </div>
                      ))
                    ) : (
                      <h5>No Data Found</h5>
                    )}
                  </div>
                </div>
              </div>
              <div className="left">
                <h1 className="title">Bank Information</h1>

                <div className="item">
                  <div className="details profile-info">
                    <div className="detailItem">
                      <span className="itemKey">Bank Name:</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.bank_name}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Account Number</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.account_number
                        }
                      </span>
                    </div>
                    <div className="detailItem">
                      <span className="itemKey">Bank Institution:</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.institution}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Bank Transit Number</span>
                      <span className="itemValue">
                        {
                          userInfo?.profile_individual_bankdetails
                            ?.transit_number
                        }
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Bank Swift Code</span>
                      <span className="itemValue">
                        {userInfo?.profile_individual_bankdetails?.swift_code}
                      </span>
                    </div>

                    <div className=" idDocs">
                      <span className="itemKey">Bank Docs</span>
                      <div className="itemValue">
                        <a
                          href={
                            userInfo?.profile_individual_bankdetails?.bankdoc
                          }
                          target="_blank"
                          className="docLink"
                        >
                          {userInfo?.profile_individual_bankdetails?.bankdoc !==
                            null && <img src={PDF} className="docImage" />}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="left">
                <div className="item">
                  <div className="details profile-info">
                    <div className="submitButton">
                      <Button
                        variant="contained"
                        className="approveButton paseCampBtn"
                        onClick={pauseCampaign}
                      >
                        Active Campaign
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ))}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="modal-popup">
              <div className="modal-top">
                <Typography id="modal-modal-title" variant="h6" component="h2">
                  Campaign Activity
                </Typography>
                <Button className="closeBtn" onClick={() => setOpen(false)}>
                  <img src={Close} alt="close-icon" />
                </Button>
              </div>
              <Typography id="modal-modal-description" sx={{ mt: 1 }}>
                <div className="new">
                  <div className="newContainer">
                    <div
                      className="bottom"
                      style={{ boxShadow: "none", padding: "0" }}
                    >
                      <div className="right">
                        <form className="accredited-investorForm">
                          {history.length > 0 ? (
                            <div className="history-infoWrap">
                              {/* <p className="createdAt-value">
                            {dateFormat(history?.[0]?.timestamp)}
                          </p> */}

                              {/* <p className="campName-value">
                            {
                              history?.[0]?.campaign_detail
                                ?.corporation_legal_name
                            }
                          </p> */}
                              {/* <p className="status-value">
                            {history?.[0]?.action}
                          </p> */}
                              <p className="campCreated-name">
                                {history?.[0]?.user?.firstname}
                                &nbsp;
                                {history?.[0]?.user?.lastname}&nbsp; Updated The
                                Status to &nbsp;
                                {history?.[0]?.action}&nbsp; on &nbsp;
                                {dateFormat(history?.[0]?.timestamp)}&nbsp; For
                                &nbsp;
                                {
                                  history?.[0]?.campaign_detail
                                    ?.corporation_legal_name
                                }
                                &nbsp; Campaign.
                              </p>
                            </div>
                          ) : (
                            <h3>No Data Found</h3>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </Typography>
            </Box>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default PausedCampaignView;
